module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "members",
    attrs: {
      "id": "members"
    }
  }, [_c('div', {
    staticClass: "members_image"
  }, [_c('div', {
    staticClass: "members_image_content"
  }, [_c('img', {
    staticClass: "members_image_content_img",
    attrs: {
      "src": _vm.dataMembers.img
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "members_image_content_name"
  }, [_vm._v(_vm._s(_vm.dataMembers.nick))])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "members_description"
  }, [_c('p', {
    staticClass: "members_description_title"
  }, [_vm._v("NASZA KOMPANIA")]), _vm._v(" "), _c('ul', {
    staticClass: "mmembers_description_list"
  }, [_c('li', {}, [_c('a', {
    staticClass: "list list-axe list--img list_img-axe",
    class: {
      active: _vm.activeSigwar
    },
    on: {
      "click": function($event) {
        _vm.write(0)
      }
    }
  })]), _vm._v(" "), _c('li', {}, [_c('a', {
    staticClass: "list list-sword list--img list_img-sword",
    class: {
      active: _vm.activeAima
    },
    on: {
      "click": function($event) {
        _vm.write(1)
      }
    }
  })]), _vm._v(" "), _c('li', {}, [_c('a', {
    staticClass: "list list-mace list--img list_img-mace",
    class: {
      active: _vm.activeHarun
    },
    on: {
      "click": function($event) {
        _vm.write(2)
      }
    }
  })]), _vm._v(" "), _c('li', {}, [_c('a', {
    staticClass: "list list-wand list--img list_img-wand",
    class: {
      active: _vm.activeBlaku
    },
    on: {
      "click": function($event) {
        _vm.write(3)
      }
    }
  })]), _vm._v(" "), _c('li', {}, [_c('a', {
    staticClass: "list list-dagger list--img list_img-dagger",
    class: {
      active: _vm.activeAmir
    },
    on: {
      "click": function($event) {
        _vm.write(4)
      }
    }
  })]), _c('li', {}, [_c('a', {
    staticClass: "list list-shield list--img list_img-shield",
    class: {
      active: _vm.activeKwasior
    },
    on: {
      "click": function($event) {
        _vm.write(5)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "members_description_name_person"
  }, [_c('div', {
    staticClass: "members_description_name_person_hr"
  }), _vm._v(" "), _c('h2', {
    staticClass: "members_description_name_person_title"
  }, [_vm._v("\n        " + _vm._s(_vm.dataMembers.name) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "members_description_name_person_hr"
  })]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n      " + _vm._s(_vm.dataMembers.description) + "\n      ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "members_image_content_hr"
  }, [_c('div', {
    staticClass: "members_image_content_hr_left"
  }), _vm._v(" "), _c('div', {
    staticClass: "members_image_content_hr_right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "members_line"
  }, [_c('div', {
    staticClass: "members_line_circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "members_line_hr"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f20536d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Members/members.vue
// module id = 32
// module chunks = 0